import { PAYMENT_PROVIDER } from 'types/enums';
import { resolveProvider } from 'config/providers';
import { FirstCheckoutCardHandler } from './card/FirstCheckoutHandler';
import { PayloftCardHandler } from './card/PayloftHandler';
import { PayStackCardHandler } from './card/PayStackHandler';
import { PayStackTransferHandler } from './transfer/PayStackTransferHandler';
import { FirstCheckoutTransferHandler } from './transfer/FirstCheckoutTransferHandler';
import { ICardHandler, ITransferHandler } from './types';

interface ProviderCapabilities {
  card?: ICardHandler;
  transfer?: ITransferHandler;
}

const REGISTRY: Record<PAYMENT_PROVIDER, ProviderCapabilities> = {
  [PAYMENT_PROVIDER.PAYSTACK]: {
    card: new PayStackCardHandler(),
    transfer: new PayStackTransferHandler(),
  },
  [PAYMENT_PROVIDER.PAYLOFT]: {
    card: new PayloftCardHandler(),
  },
  [PAYMENT_PROVIDER.FIRSTCHEKOUT]: {
    card: new FirstCheckoutCardHandler(),
    transfer: new FirstCheckoutTransferHandler(),
  },
};

export const supportsTransfer = (provider: PAYMENT_PROVIDER): boolean =>
  !!REGISTRY[provider]?.transfer;

export class PaymentHandlerFactory {
  static card(provider?: PAYMENT_PROVIDER): ICardHandler {
    const resolved = resolveProvider(provider);
    return (
      REGISTRY[resolved].card ??
      (REGISTRY[PAYMENT_PROVIDER.PAYSTACK].card as ICardHandler)
    );
  }

  /**
   * Falls back to Paystack when the resolved provider has no transfer
   * capability, so the transfer rail always has a handler.
   */
  static transfer(provider?: PAYMENT_PROVIDER): ITransferHandler {
    const resolved = resolveProvider(provider);
    return (
      REGISTRY[resolved].transfer ??
      (REGISTRY[PAYMENT_PROVIDER.PAYSTACK].transfer as ITransferHandler)
    );
  }
}
